import React, { useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { isNullOrUndefined } from "../../utils/generalValidators"; // <-- Validador importado

const useStyles = makeStyles(() => ({
  tapeWrapper: {
    width: "100%",
    overflowX: "auto",
    padding: "10px 0",
    "&::-webkit-scrollbar": {
      height: "6px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#ccc",
      borderRadius: "4px",
    },
    scrollBehavior: "smooth",
  },
  tapeContainer: {
    display: "flex",
    width: "max-content",
    margin: "0 auto",
    gap: "2px",
    alignItems: "center",
  },
  tapeCell: {
    minWidth: "28px",
    height: "32px",
    border: "1px solid #777",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
    fontSize: "0.85rem",
    fontWeight: "bold",
    position: "relative",
    borderRadius: "3px",
    flexShrink: 0,
    color: "#333",
    boxSizing: "border-box",
    transition: "all 0.2s ease",
  },
  activeCell: {
    backgroundColor: "#4caf50",
    color: "#fff",
    borderColor: "#2e7d32",
    transform: "scale(1.15)",
    zIndex: 10,
    boxShadow: "0 3px 6px rgba(0,0,0,0.2)",
  },
  markerCell: {
    backgroundColor: "#ff9800",
    color: "#fff",
    borderColor: "#ef6c00",
  },
}));

const parseTape = (tapeStr) => {
  if (isNullOrUndefined(tapeStr)) {
    return [];
  }
  if (Array.isArray(tapeStr)) {
    return tapeStr;
  }

  const cleanStr = String(tapeStr).replace(/[[\]]/g, "").trim();
  if (!cleanStr) {
    return [];
  }

  return cleanStr
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
};

export default function TapeVisualizer({ tapeContent, headPosition }) {
  const classes = useStyles();

  const wrapperRef = useRef(null);
  const activeCellRef = useRef(null);

  const tapeArray = parseTape(tapeContent);
  const numericHeadPos = Number(headPosition);

  useEffect(() => {
    if (activeCellRef.current && wrapperRef.current) {
      const wrapper = wrapperRef.current;
      const activeCell = activeCellRef.current;

      wrapper.scrollLeft =
        activeCell.offsetLeft -
        wrapper.offsetWidth / 2 +
        activeCell.offsetWidth / 2;
    }
  }, [numericHeadPos, tapeContent]);

  if (tapeArray.length === 0) {
    return null;
  }

  return (
    <div className={classes.tapeWrapper} ref={wrapperRef}>
      <div className={classes.tapeContainer} style={{ minHeight: "45px" }}>
        {tapeArray.map((symbol, index) => {
          const isHead = index === numericHeadPos;
          const isMarker = symbol === "<" || symbol === ">";

          const cellClasses = [
            classes.tapeCell,
            isHead && classes.activeCell,
            !isHead && isMarker && classes.markerCell,
          ]
            .filter(Boolean)
            .join(" ");

          return (
            <div
              key={index}
              ref={(isHead && activeCellRef) || null}
              className={cellClasses}
            >
              {symbol}
            </div>
          );
        })}
      </div>
    </div>
  );
}
